// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import Thead from './Thead'
import _ from 'lodash'
import PublicLink from './PublicLink'
import { Logo } from './elements'
import ErrorVibesLink from '../controls/ErrorVibesLink'
import VerticallyCentralizedItems from '../controls/VerticallyCentralizedItems'
import { Table, BodyRow, Cell } from '../MainTable'

type Props = {|
  isTokenPresent: boolean,
  isTokenDeactivated: boolean,
  updatePublicsPath: string,
  updateTokenPath: string,
  publics: Array<Object>,
  isLocked: boolean,
  onAjaxStarted: () => void,
  onAjaxFinished: () => void
|}

type State = {|
  publics: Array<Object>
|}

const t = translateFunc(translations.provider_publics.facebook_publics)

const ADS_ACCESS = {
  NO_ACCESS: 'no_access',
  ACCESS_REQUESTED: 'access_requested',
  HAS_ACCESS: 'has_access'
}

export default class FacebookPublics extends Component<Props, State> {
  state = {
    publics: this.props.publics
  }

  isLocked() {
    const { isLocked, isTokenDeactivated } = this.props
    return isTokenDeactivated || isLocked
  }

  renderAction(aPublic: Object) {
    const { onAjaxStarted, onAjaxFinished } = this.props

    switch (aPublic.ads_access) {
      case ADS_ACCESS.NO_ACCESS:
        return (
          <PublicLink
            id={aPublic.id}
            onAjaxStarted={onAjaxStarted}
            onAjaxFinished={onAjaxFinished}
            isLocked={this.isLocked()}
            actionName={t('request_access')}
            actionUrl={aPublic.requestAccessPath}
            provider="facebook"
            instructions
            onAccessChange={(id, adsAccess) => {
              this.adsAccessChanged(id, adsAccess)
            }}
          />
        )
      case ADS_ACCESS.ACCESS_REQUESTED:
        return (
          <PublicLink
            id={aPublic.id}
            onAjaxStarted={onAjaxStarted}
            onAjaxFinished={onAjaxFinished}
            isLocked={this.isLocked()}
            actionName={t('check_access')}
            actionUrl={aPublic.requestAccessPath}
            provider="facebook"
            instructions={false}
            onAccessChange={(id, adsAccess) => {
              this.adsAccessChanged(id, adsAccess)
            }}
          />
        )
      case ADS_ACCESS.HAS_ACCESS:
        return t('has_access')
    }
  }

  adsAccessChanged(id: number, adsAccess: string) {
    const publics = this.state.publics.map((aPublic) => {
      if (aPublic.id === id) {
        const dup = { ...aPublic }
        dup['ads_access'] = adsAccess
        return dup
      }

      return aPublic
    })

    this.setState({ publics })
  }

  renderButton() {
    const { isTokenPresent, updatePublicsPath, updateTokenPath, isTokenDeactivated } = this.props

    if (isTokenPresent && !isTokenDeactivated) {
      return (
        <a data-method="post" className="top-info__button" href={updatePublicsPath}>
          {t('refresh_list')}
        </a>
      )
    } else if (isTokenDeactivated) {
      return (
        <ErrorVibesLink className="top-info__button" href={updateTokenPath}>
          {t('refresh_token')}
        </ErrorVibesLink>
      )
    } else {
      return (
        <a className="top-info__button" href={updateTokenPath}>
          {t('refresh_list')}
        </a>
      )
    }
  }

  render() {
    const { isTokenPresent, updatePublicsPath, updateTokenPath } = this.props
    const { publics } = this.state

    return (
      <div>
        <div className="top-info">
          <h1>{t('title')}</h1>
          {this.renderButton()}
        </div>
        {!_.isEmpty(publics) ? (
          <Table>
            <Thead />
            <tbody>
              {publics.map((aPublic) => (
                <BodyRow key={aPublic.id}>
                  <Cell>
                    <VerticallyCentralizedItems>
                      <Logo src={aPublic.image_url} />
                      <a target="blank" href={`https://facebook.com/${aPublic.external_id}`}>
                        {aPublic.label}
                      </a>
                    </VerticallyCentralizedItems>
                  </Cell>
                  <Cell>{this.renderAction(aPublic)}</Cell>
                </BodyRow>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>
            {t('no_publics')}{' '}
            {isTokenPresent ? (
              <a data-method="post" href={updatePublicsPath}>
                {t('refresh_button')}
              </a>
            ) : (
              <a href={updateTokenPath}>{t('refresh_button')}</a>
            )}
            {'.'}
          </p>
        )}
      </div>
    )
  }
}
